import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import { Accordion, Dropdown } from "react-bootstrap";
import newIcon from "../../assets/newIcn.png";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import Loader from "../UI Component/Loader/Loader";
import RegisterModal from "./registerModal";
import UpcomingWebinarRow from "./upcomingWebinarRow";
import NoDate from "../../assets/Webinar_Placeholder@2x.png";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

const filter = [
  { name: "Oldest to Newest", value: "asc" },
  {
    name: "Newest to Oldest",
    value: "desc",
  },
];

const webinarList = [
  {
    title: "Webinar 1",
    moderator: "Dr Vinay Kumar",
    date: "20-Aug-2021",
    start_time: "10:00 AM",
    end_time: "02:00 PM",
  },
  {
    title: "Webinar 1",
    moderator: "Dr Vinay Kumar",
    date: "20-Aug-2021",
    start_time: "10:00 AM",
    end_time: "02:00 PM",
  },
];
const DoctorUpcomingWebinars = ({ filterUpcomingValue }) => {
  const [upcomingWebinarList, setupcomingWebinarList] = useState([]);
  const [pageLoader, setpageLoader] = useState(false);
  const [registredWebinar, setRegistredWebinar] = useState({});
  const [registerModal, setRegistredModal] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [filterValue, setFilterValue] = useState(filterUpcomingValue);

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  useEffect(() => {
    getUpComingWebinar();
  }, [filterValue]);

  const getUpComingWebinar = () => {
    let is_partial_doctor = localStorage.getItem("is_partial_doctor");
    setpageLoader(true);
    afterLoginApiAxios
      .post(
        "/doctor/get-upcoming-webinars",
        {
          "authorizer-principal-id": {
            user_type: "1",
            user_id: userId,
          },
          doctor_id: userId,
          doctor_specialization_id: localStorage.getItem("specialization"),
          sort_order: filterValue,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((res) => {
        if (res && res.data.statusCode === 200) {
          if (
            res.data &&
            res.data.upcoming_webinar_list &&
            res.data.upcoming_webinar_list.length > 0
          ) {
            if (is_partial_doctor == "True") {
              let filterDate = res.data.upcoming_webinar_list.filter(
                (data) => data.exclude_partial_doctors !== "True"
              );
              setupcomingWebinarList(filterDate);
            } else {
              setupcomingWebinarList(res.data.upcoming_webinar_list);
            }
          }
        } else {
          setpageLoader(false);
        }
        setpageLoader(false);
      })
      .catch((error) => {
        C2CConsole.log(error.message);
      });
  };

  const RegisterWebinar = (webinar) => {
    setDisableBtn(true);
    setRegistredWebinar(webinar);
    afterLoginApiAxios
      .post(
        "/doctor/webinar-registration",
        {
          "authorizer-principal-id": {
            user_type: "1",
            user_id: userId,
          },
          staff_id: null,
          doctor_id: userId,
          webinar_id: webinar.webinar_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((res) => {
        if (res && res.data.statusCode === 200) {
          setRegistredModal(true);
        } else {
          C2CConsole.log("error");
        }
        setDisableBtn(false);
      })
      .catch((error) => {
        C2CConsole.log(error.message);
      });
  };

  return (
    <>
      {pageLoader ? (
        <Loader />
      ) : (
        <>
          {upcomingWebinarList && upcomingWebinarList.length > 0 ? (
            <div className="container-fluid bg-light py-2">
              {/* {showLoader ? <Loader /> : null} */}
              <div className="row patient-row-header align-items-center my-2 mx-0 text-uppercase d-none d-md-flex">
                <div className="col ">webinar title</div>
                <div className="col">moderator</div>
                {/* <div className="col">Date & time</div> */}
                <div className="col d-flex status">
                  <p className="appointment-table-status-col">Date & time</p>
                  <Dropdown size="sm">
                    <Dropdown.Toggle
                      id="dropdownMenu2"
                      className="appointment-dropdown-toggle"
                    >
                      <img
                        className="appointment-calendar-icon"
                        src={newIcon}
                      />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="appointment-table-dropdown-menu">
                      {filter.map((item, index) => (
                        <Dropdown.Item
                          onClick={() => setFilterValue(item.value)}
                          className="appointment-dropdown-item d-flex text-label"
                          key={index}
                        >
                          <i
                            className={`fa fa-check mr-3 check-icon-filter ${
                              filterValue === item.value ? "activeTab" : ""
                            }`}
                            aria-hidden="true"
                          ></i>
                          {item.name}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
                <div className="col">action</div>
              </div>

              {upcomingWebinarList && upcomingWebinarList.length > 0 ? (
                <React.Fragment>
                  {upcomingWebinarList.map((webinar, index) => (
                    <UpcomingWebinarRow
                      webinar={webinar}
                      key={index}
                      index={index}
                      registerWebinar={RegisterWebinar}
                      disableBtn={disableBtn}
                    />
                  ))}
                </React.Fragment>
              ) : (
                <span>
                  {/* {showLoader == false ? ( */}
                  <div className="row upcomingList p-2 mt-2 text-center">
                    <div
                      className="col-sm-12 col-lg-12 pt-1"
                      style={{ fontSize: "12px" }}
                    >
                      No Records Found
                    </div>
                  </div>
                  {/* ) : null} */}
                </span>
              )}
            </div>
          ) : (
            <div className="d-flex justify-content-center align-items-center flex-column no_data">
              <img src={NoDate} alt="" width={297} height={170} />
              <h5 className="mt-2">No Upcoming Webinars</h5>
              <p style={{ color: "#707070" }}>
                You will see all upcoming webinars listed here once they are
                scheduled by the Connect2Clinic team.
              </p>
            </div>
          )}
        </>
      )}

      <RegisterModal
        show={registerModal} //true
        registredWebinar={registredWebinar}
        handleClose={() => {
          setRegistredModal(false);
          getUpComingWebinar();
        }}
      />
    </>
  );
};

export default DoctorUpcomingWebinars;
